/* eslint-disable id-length */
export const ADELPHI_STATEMENTS_TARGETS = {
  ADELPHI_STATEMENTS: 'adelphiStatements',
  ADELPHI_STATEMENT_BY_ID: 'adelphiStatementById',
  ADELPHI_STATEMENT_CSV_BY_ID: 'adelphiStatementCSVById',
  CREATE_ADELPHI_STATEMENT: 'createAdelphiStatement',
  CURRENT_ADELPHI_STATEMENT: 'currentAdelphiStatement'
};

export const ADELPHI_STATEMENTS_DEFAULT_STATE = {
  [ADELPHI_STATEMENTS_TARGETS.ADELPHI_STATEMENTS]: [],
  [ADELPHI_STATEMENTS_TARGETS.ADELPHI_STATEMENT_BY_ID]: {},
  [ADELPHI_STATEMENTS_TARGETS.ADELPHI_STATEMENT_CSV_BY_ID]: {},
  [ADELPHI_STATEMENTS_TARGETS.CREATE_ADELPHI_STATEMENT]: null,
  [ADELPHI_STATEMENTS_TARGETS.CURRENT_ADELPHI_STATEMENT]: null
};
